const scripts = {
  facebook: 'https://connect.facebook.net/pt_BR/sdk.js',
  instagram: 'https://www.instagram.com/embed.js',
  twitter: 'https://platform.twitter.com/widgets.js',
  one_signal: 'https://cdn.onesignal.com/sdks/OneSignalSDK.js',
  webpushr: 'https://cdn.webpushr.com/app.min.js',
  fox_push: '//cdn.foxpush.net/sdk/foxpush_SDK_min.js'
}

export const addScript = (key, id = null) => {
  let src = null

  if (!scripts[key]) {
    return
  } else if (scripts[key]) {
    src = scripts[key]
  } else {
    src = key
  }

  if(document.querySelector(`script[src="${src}"]`)) {
    return
  }

  let script = document.createElement("script")
  script.src = src;
  script.async = true
  script.defer = true

  if (id) {
      script.id = id
  }

  document.body.appendChild(script)
}

export default (entry) => {
  addScript(entry.target.dataset.type)
}